type TextareaFieldProps = {
  id: string;
  name: string;
  label: string;
  value: string;
  placeholder?: string;
  rows?: number;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

export const TextareaField = ({
  id,
  name,
  label,
  value,
  placeholder,
  rows = 3,
  onChange,
}: TextareaFieldProps) => {
  return (
    <div>
      <label
        htmlFor={id}
        className="block text-[16px] md:text-[17px] font-medium text-[#111827] mb-2"
      >
        {label} <span className="text-red-500">*</span>
      </label>
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required
        rows={rows}
        placeholder={placeholder}
        className="w-full rounded-md border border-gray-300 px-3 py-2 text-[16px] text-[#111827] placeholder:text-gray-400 focus:border-[#026857] focus:outline-none focus:ring-2 focus:ring-[#026857]/20 resize-none"
      />
    </div>
  );
};

